import RequestList from '../../components/RequestList';
import * as React from 'react';
// @ts-ignore
import { useCallback, useLayoutEffect, useState } from 'react';
import * as _ from 'lodash';
import Select from 'react-select';
import { mapFormsFiltersToAPI } from '../../lib/mappers/RequestMain';
import { getConfig } from '../../components/Utils';
import { FORM_KIND } from '../../const/forms';

const defaultFormState = {
  view: null,
  regNum1C: null,
  name: null,
  dateFrom: null,
  dateTo: null,
  regNumLK: null,
};

const formKindBaseOptions = Object.entries(FORM_KIND).map(([id, name]) => ({
  id,
  name,
  value: id,
  label: name,
}));

const formKindOptions = [
  { id: '1', name: 'Не выбрано', value: undefined, label: 'Не выбрано' },
  ...formKindBaseOptions,
];

const RequestMainPage = ({ mode, user, forms, getForms, getExcelForms }) => {
  const [formState, setFormState] = useState(defaultFormState);
  const [showHint, setShowHint] = useState(false);
  const [xlsxLink, setXlsxLink] = useState('');

  useLayoutEffect(() => {
    if (!checkValidDates(formState)) return;
    handleEventsWithDebounce();
  }, [formState]);

  const checkValidDates = filters => {
    const dates = [filters.dateFrom, filters.dateTo];

    for (let date of dates) {
      if (!date) continue;
      if (new Date(date).getFullYear() < 1000) return false;
    }

    return true;
  };

  const sendFilter = () => {
    getForms({ filters: formState });
  };

  const generateXlsxLink = () => {
    const baseUrl = getConfig().apiUrl + '/export/xlsx';

    const filters = mapFormsFiltersToAPI(formState);

    let formFiltersPartUrl = '';

    Object.entries(filters).forEach(([key, value]) => {
      if (formFiltersPartUrl === '') {
        formFiltersPartUrl += !!value ? `?${key}=${value}` : '';
        return;
      }

      formFiltersPartUrl += !!value ? `&${key}=${value}` : '';
    });

    setXlsxLink(`${baseUrl}${formFiltersPartUrl}`);
  };

  const handleEventsWithDebounce = _.debounce(() => {
    sendFilter();
    generateXlsxLink();
  }, 1000);

  const handleFormChange = e => {
    setFormState({
      ...formState,
      [e.target.id]: e.target.value,
    });
  };

  return (
    <div className="content">
      <div className="d-flex">
        <h2 className="content__title">
          Запросы Инвесторов и заявки Участников
        </h2>
        <button
          type="button"
          className="btn btn-clear"
          onClick={() => setShowHint(!showHint)}
        >
          <span className="glyphicon glyphicon-question-sign"></span>
        </button>
      </div>
      {showHint && <div className="alert alert-info hint">TODO Подсказка</div>}

      <div className="line" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-6">
            <h4>Фильтр</h4>
          </div>
          <div className="col-xs-6">
            <a
              style={{
                display: 'block',
                width: 'fit-content',
                marginLeft: 'auto',
              }}
              className="btn btn-success"
              href={xlsxLink}
              download
            >
              Загрузить в excel
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <div className="form-group">
              <label htmlFor="view">Вид заявителя</label>
              <Select
                autosize={false}
                name="form-field-name"
                className="has-success"
                placeholder="Выберите вид заявителя"
                value={formState['view']}
                style={{
                  width: '100%',
                  borderColor: formState['view'] ? '#4eb43e' : '#ccc',
                }}
                onChange={e => {
                  handleFormChange({
                    target: {
                      id: 'view',
                      value: e.value,
                    },
                  });
                }}
                clearable={false}
                noResultsText="Список пуст"
                options={formKindOptions}
              />
            </div>
          </div>

          <div className="col-xs-6">
            <div className="form-group">
              <label htmlFor="regNum1C">Рег.№ в 1С-BPS</label>
              <input
                type="input"
                className="form-control"
                id="regNum1C"
                value={formState['regNum1C']}
                onChange={handleFormChange}
                placeholder="Рег.№ в 1С-BPS"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label htmlFor="name">Наименование заявителя</label>
              <input
                type="input"
                className="form-control"
                id="name"
                value={formState['name']}
                onChange={handleFormChange}
                placeholder="Наименование заявителя"
              />
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label htmlFor="dateFrom">Дата подачи</label>
              <div className="row">
                <div
                  className="col-sm-6 col-xs-12"
                  style={{
                    display: 'grid',
                    alignItems: 'center',
                    gridTemplateColumns: '23px 1fr',
                    marginBottom: '8px',
                  }}
                >
                  <span>с</span>
                  <input
                    type="date"
                    className="form-control"
                    id="dateFrom"
                    value={formState['dateFrom']}
                    onChange={handleFormChange}
                    placeholder="Дата подачи с"
                  />
                </div>
                <div
                  className="col-sm-6 col-xs-12"
                  style={{
                    display: 'grid',
                    alignItems: 'center',
                    gridTemplateColumns: '23px 1fr',
                    marginBottom: '8px',
                  }}
                >
                  <span>по</span>
                  <input
                    type="date"
                    className="form-control"
                    id="dateTo"
                    value={formState['dateTo']}
                    onChange={handleFormChange}
                    placeholder="Дата подачи по"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label htmlFor="regNumLK">Рег.№ в ЛК</label>
              <input
                type="input"
                className="form-control"
                id="regNumLK"
                value={formState['regNumLK']}
                onChange={handleFormChange}
                placeholder="Рег.№ в ЛК"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="line" />
      <div className="container-fluid nopad">
        {/* @ts-ignore */}
        <RequestList view="adminFilters" />
      </div>
    </div>
  );
};
export default RequestMainPage;
